export default [
  {
    path: '/apps/tb-extensao/list',
    name: 'apps-tb-extensao-list',
    component: () => import('@/views/app/tb-extensao/tb-extensao-list/TbExtensaoList.vue'),
    meta: {
      pageTitle: 'Tabela Extensão',
    },
  },
  {
    path: '/apps/tb-extensao/edit/:id',
    name: 'apps-tb-extensao-edit',
    component: () => import('@/views/app/tb-extensao/tb-extensao-edit/TbExtensaoEdit.vue'),
    meta: {
      pageTitle: 'Editar Tabela',
    },

  },
];
